import { render, staticRenderFns } from "./matchAnswers.vue?vue&type=template&id=4223a54e&scoped=true&"
import script from "./matchAnswers.vue?vue&type=script&lang=js&"
export * from "./matchAnswers.vue?vue&type=script&lang=js&"
import style0 from "./matchAnswers.vue?vue&type=style&index=0&id=4223a54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4223a54e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VHover,VIcon,VSheet})
